import { REHYDRATE } from "redux-persist";
import update from "immutability-helper";

import { ANY_FIELD_UPDATE, updatedObject } from "actions/formActions";
import { LOGOUT } from "actions/loginStateActions";
import {
    REMOVE_IMPORTED_FILE,
    SELECTED_CONTACTS_UPDATE,
    IMPORT_EXCEL_FILES_BEGIN,
    IMPORT_EXCEL_FILES_SUCCESS,
    IMPORT_EXCEL_FILES_FAIL,
    SUPPLIER_IMPORT_INVITE_BEGIN,
    SUPPLIER_IMPORT_INVITE_SUCCESS,
    SUPPLIER_IMPORT_INVITE_FAIL,
    SUPPLIER_INVITATION_RESET,
    SUPPLIER_INVITATION_INIT,
} from "./types";
import INITIAL_STATE from "./state";

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case REHYDRATE:
            return state;

        case ANY_FIELD_UPDATE: {
            if (action.storeName !== "supplierInvitation") return state;

            return { ...state, data: updatedObject(state.data, action.accessPath, action.newVal) };
        }

        case REMOVE_IMPORTED_FILE:
            return update(state, {
                data: {
                    validFiles: {
                        $apply: files => files.filter(({ key }) => key !== action.key),
                    },
                },
            });

        case SELECTED_CONTACTS_UPDATE:
            return update(state, {
                data: { selectedContacts: { $set: action.selectedContacts } },
            });

        //
        //  ******* Import Excel files Related *******
        //

        case IMPORT_EXCEL_FILES_BEGIN:
            return update(state, { status: { $set: "importing" } });

        case IMPORT_EXCEL_FILES_SUCCESS:
            return update(state, {
                data: { validFiles: { $push: action.validFiles } },
                status: { $set: "editing" },
            });

        case IMPORT_EXCEL_FILES_FAIL:
            return update(state, { error: { $set: action.reason }, status: { $set: "editing" } });

        //
        //  ******* Email Invitation Related *******
        //

        case SUPPLIER_IMPORT_INVITE_BEGIN:
            return update(state, { status: { $set: "submitting" } });

        case SUPPLIER_IMPORT_INVITE_SUCCESS:
            return update(state, {
                data: { selectedContactsNo: { $set: action.selectedContactsNo } },
                status: { $set: "completed" },
            });

        case SUPPLIER_IMPORT_INVITE_FAIL:
            return update(state, { status: { $set: "failed" }, error: { $set: action.reason } });

        case SUPPLIER_INVITATION_INIT:
            return update(state, { status: { $set: INITIAL_STATE.status } });

        case SUPPLIER_INVITATION_RESET:
        case LOGOUT:
            return INITIAL_STATE;

        default:
            return state;
    }
};
